import { makeStyles } from "@material-ui/core/styles";
import React, { useContext } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import InfoIcon from "@material-ui/icons/Info";
import { commonsStoreContext } from "../../model/CommonsStore";
import Chip from "@material-ui/core/Chip";
import { Typography } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import { i18nContext } from "../../model/I18n";

const useStyles = makeStyles({
  noMaxWidth: {
    maxWidth: "none"
  },
  siteMargin: {
    marginRight: 8
  }
});

const VersionField = (props: { label: string; value: string }) => {
  const { label, value } = props;
  return (
    <div
      style={{ display: "grid", gridTemplateRows: "auto auto", minWidth: 140 }}
    >
      <Typography style={{ opacity: 0.7 }} variant={"caption"}>
        {label}
      </Typography>
      <Typography>{value}</Typography>
    </div>
  );
};

export const AppVersion = observer(() => {
  const classes = useStyles();
  const { apiVersion } = useContext(commonsStoreContext);
  const { guiVersion } = useContext(commonsStoreContext);

  const i18n = useContext(i18nContext);
  const guiVersionTitle = i18n.t("lego:header.guiVersion", "GUI VERSION");
  const apiVersionTitle = i18n.t("lego:header.apiVersion", "API VERSION");
  const version = i18n.t("lego:header.version", "VERSION");

  const showVersion = () => {
    if (apiVersion && guiVersion) {
      return (
        <>
          <VersionField label={guiVersionTitle} value={guiVersion} />
          <VersionField
            label={apiVersionTitle}
            value={apiVersion.commitIdDescribeShort}
          />
        </>
      );
    } else {
      return (
        <>
          <VersionField
            label={version}
            value={
              apiVersion
                ? apiVersion.commitIdDescribeShort
                : guiVersion
                ? guiVersion
                : "DEV"
            }
          />
        </>
      );
    }
  };

  return (apiVersion && apiVersion.commitIdDescribeShort) || guiVersion ? (
    <>
      {apiVersion && apiVersion.site && (
        <Chip
          className={classes.siteMargin}
          label={apiVersion.site}
          color={"secondary"}
          variant={"outlined"}
          size={"small"}
        />
      )}
      <Tooltip classes={{ tooltip: classes.noMaxWidth }} title={showVersion()}>
        <IconButton color={"inherit"} aria-label="app-version">
          <InfoIcon />
        </IconButton>
      </Tooltip>
    </>
  ) : null;
});
